"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useDOMLibrary;

var _dom = _interopRequireDefault(require("./_dom"));

var _mq = _interopRequireDefault(require("./_dom/mq"));

// forces Matrsahka to use jQuery-like DOM library for internal stuff
function useDOMLibrary(library) {
  if (typeof library === 'function') {
    _dom["default"].$ = library;
  } else {
    _dom["default"].$ = _mq["default"];
  }
}
//# sourceMappingURL=usedomlibrary.js.map